<template>
  <div class="c-task-filter-group">
    <div class="c-task-filter-members">
      <el-popover
        v-model="isVisible"
        trigger="click"
        popper-class="c-task-filter-popover"
        @hide="handleSelectUserClose"
      >
        <div
          slot="reference"
          class="c-task-filter-member-inner"
        >
          <user-pic
            :users="selectedUsers"
            :maxLength="3"
            :props="{
              id: 'userId',
              pic: 'userPic'
            }"
          />
          <div class="c-task-filter-member-label" >
            <span v-if="selectedUsers.length===0">无</span>
            <span v-if="isSelf">我</span>
            <i class="ibass ibass-trig-down" />
          </div>
        </div>
        <user-selector
          :users="users"
          :defaultUsers="selectedUsers"
          @selectUser="handleUserSelect"
        />
      </el-popover>
    </div>
  </div>
</template>
<script>
import UserSelector from './UserSelector'
import UserPic from './UserPicList'
import { TASK_STATUS } from '@/utils/constants'
import _ from 'lodash'
export default {
  name: 'TaskFilterGroup',
  components: {
    UserSelector,
    UserPic
  },
  props: {
    users: {
      type: Array
    },
    showMember: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default () {
        return {
          id: 'userId',
          pic: 'userPic'
        }
      }
    },
    defaultStatus: {
      type: Array,
      default () {
        return Object.values(TASK_STATUS)
      }
    }
  },
  data () {
    return {
      isVisible: false,
      selectedUsers: [],
      currentSelected: this.$store.state.calendar.reqParams.status
    }
  },
  computed: {
    isSelf () {
      let sUserId = this.selectedUsers && this.selectedUsers[0] && this.selectedUsers[0].userId
      return sUserId === this.$store.state.user.user.id
    },
    showSelectUsers () {
      return this.selectedUsers.slice(0, this.maxLength)
    }
  },
  watch: {
    users () {
      // 初始化选中的人，初始化项目查询
      let users = this.$store.state.calendar.reqParams.users
      this.selectedUsers = this.users.filter(user => users.some(ruser => ruser.userId === user.userId))
    }
  },
  methods: {
    handleUserSelect (selectedUsers) {
      this.selectedUsers = selectedUsers
      this.commitSelectedUser()
    },
    // 默认选中自身，第零个对象
    handleSelectUserClose () {
      if (this.selectedUsers.length === 0) {
        this.selectedUsers = this.users.slice(0, 1)
        this.commitSelectedUser()
      }
    },
    commitSelectedUser () {
      if (this.updateTimer) clearTimeout(this.updateTimer)
      this.updateTimer = setTimeout(() => {
        if (this.selectedUsers.length > 0) {
          // 需要使用lodash.cloneDeep，否则，在建立对象引用以后每一次修改都会触发updateCalendarParams对应对象的检查，导致报错
          this.$store.commit('updateCalendarParams', {
            users: _.cloneDeep(this.selectedUsers),
            matters: []
          })
        }
        this.$analysis.track('筛选成员_日程安排/工作台模块')
      }, 400)
    }
  }
}
</script>
<style lang="stylus">
.c-task-filter
  &-group
    display flex
    margin-left 30px
    line-height 28px
    font-size .875rem
    color #666
  &-popover
    padding 10px 0
  &-member
    &-inner
      display flex
      cursor pointer
    &-label
      margin-top 2px
      margin-left 5px
      .ibass-trig-down
        color #B2B2B2
        margin-left 3px
        vertical-align -2px
</style>
